<template>
  <div class="report">
    <div v-for=" (items,i) in list" class="PageNext">
      <table>
        <tr>
          <th rowspan="3">月份</th>
          <th colspan="4">{{items.hospital[0]}}</th>
          <th colspan="4">{{items.hospital[1]}}</th>
          <th colspan="4">{{items.hospital[2]}}</th>
          <th colspan="4">{{items.hospital[3]}}</th>
        </tr>
        <tr>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
        </tr>
        <tr>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
        </tr>
        <tr v-for="item in items.list">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
          <td>{{item[8]}}</td>
          <td>{{item[9]}}</td>
          <td>{{item[10]}}</td>
          <td>{{item[11]}}</td>
          <td>{{item[12]}}</td>
          <td>{{item[13]}}</td>
          <td>{{item[14]}}</td>
          <td>{{item[15]}}</td>
          <td>{{item[16]}}</td>
        </tr>
        <!--<tr>-->
          <!--<td>合计</td>-->
          <!--<td>{{count(i,1)}}</td>-->
          <!--<td>{{count(i,2)}}</td>-->
          <!--<td>{{count(i,3)}}</td>-->
          <!--<td>{{count(i,4)}}</td>-->
          <!--<td>{{count(i,5)}}</td>-->
          <!--<td>{{count(i,6)}}</td>-->
          <!--<td>{{count(i,7)}}</td>-->
          <!--<td>{{count(i,8)}}</td>-->
          <!--<td>{{count(i,9)}}</td>-->
          <!--<td>{{count(i,10)}}</td>-->
          <!--<td>{{count(i,11)}}</td>-->
          <!--<td>{{count(i,12)}}</td>-->
          <!--<td>{{count(i,13)}}</td>-->
          <!--<td>{{count(i,14)}}</td>-->
          <!--<td>{{count(i,15)}}</td>-->
          <!--<td>{{count(i,16)}}</td>-->
        <!--</tr>-->
      </table>
    </div>

    <div id="qrcode"></div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Year",
    data(){
      return {
        list:[]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
         this.list=res.list;
          this.name=res.name;
        } )
      },
      count(i,j){
        let total=0
        this.list[i].list.forEach(item=>{
          if (item[j]!=="") {
            total += parseFloat(item[j])
          }
        })
        return total.toFixed(2)

      }
    },
    mounted(){
      // setTimeout(this.init,500)
    },
    created(){

     this.init()


    }
  }

</script>

<!--<style scoped>-->
  <!--.report{width: 100%;color: #000;}-->

  <!--.report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 14px;}-->
  <!--table{-->
    <!--border-collapse: collapse;-->
    <!--width: 100%;-->
    <!--margin-bottom: 30px;-->
    <!--margin-top: 10px;-->
  <!--}-->
  <!--table td{border: 1px solid #000;font-size: 10px;height: 22px;}-->
  <!--table th{border: 1px solid #000;font-size: 10px;height:22px;}-->

<!--</style>-->
<style media=print>
  .Noprint{display:none;}
  .PageNext{page-break-after: always;}
</style>
<style scoped>
  .report{width: 100%;color: #000;}

  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 14px;}
  table{
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 30px;
    margin-top: 10px;
  }
  table td{border: 1px solid #000;font-size: 12px;height: 32px;}
  table th{border: 1px solid #000;font-size: 12px;height:32px;}
</style>



// WEBPACK FOOTER //
// src/view/report/year.vue